import React, { useRef, useEffect, useState } from "react";
import styles from "./Loading.module.css";
import { loadingState, dimLoadingState } from "@components/state";
import { useAtom } from "jotai";
import { useLocation } from "react-router-dom";

const Loading = React.memo(({ children }) => {
  const location = useLocation();
  const childRef = useRef(null);
  const [load, setLoad] = useAtom(loadingState);
  const [dimLoadState, __] = useAtom(dimLoadingState);
  const [heightDimLoad, setHeightDimLoad] = useState(0);

  // dim loading 높이 조절
  useEffect(() => {
    if (childRef.current?.offsetHeight) {
      setHeightDimLoad(Number(childRef.current?.offsetHeight));
    }
  }, [childRef.current?.offsetHeight]);
  // 페이지 이동 로딩바 설정
  useEffect(() => {
    // 2.5초 후 실행
    const timer = setTimeout(() => {
      setLoad((s) => ({ ...s, isLoad: true }));
      clearTimeout(timer);
    }, 2000);
    return () => {
      clearTimeout(timer);
    };
  }, [location]);
  return (
    <>
      {!load.isLoad && (
        <div className={styles.loadingContainer}>
          <div className={styles.chickRun} />
          {/* <div className={styles.spinner} /> */}
        </div>
      )}
      {!dimLoadState.isLoad && (
        <div
          className={styles.dimLoadingContainer}
          style={heightDimLoad ? { height: heightDimLoad + "px" } : null}
        >
          <div className={styles.chickRun} />
        </div>
      )}
      <div
        ref={childRef}
        className={!load.isLoad ? styles.waitContainer : styles.fullContainer}
      >
        {children}
      </div>
    </>
  );
});
export default Loading;
